export const LOGIN_USER = "login_user";
export const REGISTER_USER="register_user";
export const AUTH_USER="auth_user";